import { Button, Grid, Typography } from "@material-ui/core";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { Table, TableBody, TableRow, TableCell } from "@material-ui/core";
import { Split } from "../../utils/Split";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useHistory } from "react-router";
import moment from "jalali-moment";
import useCustomState from "../../hooks/State";
import AddTypeModal from "./ModalAddType";
import EditUserModal from "./ModalEditUser";
import AddCounterModal from "./ModalAddCounter";
import Call from "../../service/API";
import { useMountAPI } from "../../hooks/APICall";

const UserTableHeader = (props) => {
  const isLoading = useCustomState(true);
  const editUserModalOpen = useCustomState(false);
  const userInfo = useCustomState({});
  const userDescription = useCustomState("");

  const history = useHistory();

  const userUtils = {
    userId: props.userId,
    isLoading: isLoading,
    userInfo: userInfo,
    history: history,
  };

  useMountAPI(fetchUserInfo, userUtils);

  useEffect(() => {
    if (!isLoading.value) {
      const description = userInfo?.value.other_information?.description
        ? userInfo.value.other_information.description
        : "وارد نشده";
      userDescription.handleChange(description);
    }
  }, [isLoading.value]);

  if (!isLoading.value) {
    return (
      <>
        <EditUserModal open={editUserModalOpen} user={userInfo.value} />
        <Grid container>
          <Grid item sx={12} sm={12} md={7} lg={7}>
            <Grid align="center" item sx={12} sm={12} md={12} lg={12}>
              <div
                style={{
                  maxWidth: "820px",
                  marginTop: "48px",
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  height: "430px",
                  overflow: "scroll",
                }}
              >
                {/* <img
                  src={props.image}
                  style={{
                    width: "160px",
                    height: "160px",
                    borderRadius: "50%",
                    marginTop: "-70px",
                  }}
                  alt="project"
                /> */}
                {/* <Typography style={{ fontSize: "24px" }}>
                  {convertNumbers(
                    userInfo.value.user_name +
                      " " +
                      userInfo.value.user_lastname
                  )}
                </Typography> */}
                <Table
                  style={{
                    backgroundColor: "#fff",
                    padding: "16px",
                    borderRadius: "12px",
                    marginTop: "8px",
                  }}
                  aria-label="simple table"
                >
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <Typography>نام و نام خانوادگی</Typography>
                      </TableCell>
                      <TableCell align="center">
                        {userInfo.value.user_name +
                          " " +
                          userInfo.value.user_lastname}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography>شماره تلفن</Typography>
                      </TableCell>
                      <TableCell align="center">
                        {convertNumbers(userInfo.value.user_phone)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography>تاریخ ثبت نام</Typography>
                      </TableCell>
                      <TableCell align="center">
                        {convertNumbers(
                          moment(userInfo.value.user_create_date)
                            .locale("fa")
                            .format("YYYY/MM/DD")
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography>تعداد پروژه ها</Typography>
                      </TableCell>
                      <TableCell align="center">
                        {convertNumbers(userInfo.value.user_projects)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography>تعداد کنتورها</Typography>
                      </TableCell>
                      <TableCell align="center">
                        {convertNumbers(userInfo.value.user_water_meters)}
                      </TableCell>
                    </TableRow>

                    {userInfo.value.user_tag_info.map((info, idx) => {
                      return (
                        <TableRow>
                          <TableCell>
                            <Typography>
                              <span>میزان مصرف کنتورهای </span>
                              <span>{info.tag_name}</span>
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            {convertNumbers(info.all_tag_consumptions)}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
            </Grid>
          </Grid>

          <Grid
            style={{ paddingRight: "24px" }}
            align="center"
            item
            sx={12}
            sm={12}
            md={5}
            lg={5}
          >
            <div
              style={{
                maxWidth: "820px",
                height: "380px",
                marginTop: "48px",
                backgroundColor: "#fff",
                borderRadius: "12px",
                padding: "24px",
                overflow: "scroll",
                textAlign: "right",
              }}
            >
              <div style={{ height: "190px", overflow: "scroll" }}>
                <Typography
                  align="left"
                  style={{ fontSize: "16px", fontWeight: "bold" }}
                >
                  {"توضیحات در مورد کاربر"}
                </Typography>
                <Typography align="left" style={{ fontSize: "14px" }}>
                  {userDescription.value}
                </Typography>
              </div>
              <hr />
              <Typography
                align="left"
                style={{ fontSize: "16px", fontWeight: "bold" }}
              >
                {"امکانات"}
              </Typography>
              <br />
              <Button
                onClick={() => {
                  editUserModalOpen.handleChange(true);
                }}
                style={{
                  backgroundColor: "#ed6c02",
                  color: "#fff",
                  marginRight: "4px",
                  marginLeft: "4px",
                  marginBottom: "4px",
                }}
                variant="contained"
              >
                ویرایش کاربر
              </Button>
              {/* <Button
                style={{
                  backgroundColor: "#d32f2f",
                  color: "#fff",
                  marginRight: "4px",
                  marginLeft: "4px",
                  marginBottom: "4px",
                }}
                variant="contained"
              >
                حذف کاربر
              </Button> */}
            </div>
          </Grid>
        </Grid>
      </>
    );
  } else {
    return null;
  }
};

export default UserTableHeader;

const fetchUserInfo = (utils) => {
  const userId = utils.userId;
  const isLoading = utils.isLoading;
  const userInfo = utils.userInfo;
  const history = utils.history;

  const data = {
    other_user_id: userId,
    user_phone: null,
  };

  Call("POST", "users/admin/getOneUser", data)
    .then((response) => {
      // console.log("fetch userInfo: ", response);
      if (response.data.code == 200) {
        userInfo.handleChange(response.data.data);
        isLoading.handleChange(false);
      } else {
        history.push("/admin/users-management");
      }
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      history.push("/admin/users-management");
    });
};
